import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import React from 'react';

import LoadingPlaceholder from 'presentation/components/icons/LoadingPlaceholder';
import overrideStyle from 'lib/overrideStyle';

export default function SearchLoadingIndicator({ isLoading }) {
  return (
    <CSSTransition
      classNames="gladlySelfService-fadeInLoadingIndicator"
      exit={false}
      in={isLoading}
      mountOnEnter
      timeout={500}
      unmountOnExit
    >
      <LoadingWrapper>
        <LoadingPlaceholder color="#888" size="10px" />
      </LoadingWrapper>
    </CSSTransition>
  );
}

SearchLoadingIndicator.propTypes = {
  isLoading: PropTypes.bool,
};

const LoadingWrapper = overrideStyle('div')`
  height: 16px;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;

  &.gladlySelfService-fadeInLoadingIndicator-enter-active {
    opacity: 1;
    transition: opacity 500ms ease;
  }
  &.gladlySelfService-fadeInLoadingIndicator-enter-done {
    opacity: 1;
  }
`;
